// src/components/ReprovacaoModal.js
import React, { useState } from 'react';

function ReprovacaoModal({ isOpen, onClose, oportunidade, onConfirmar }) {
  const [motivo, setMotivo] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!motivo.trim()) {
      alert('O motivo da reprovação é obrigatório!');
      return;
    }
    
    if (motivo.trim().length < 10) {
      alert('O motivo deve ter pelo menos 10 caracteres!');
      return;
    }
    
    setEnviando(true);
    
    try {
      await onConfirmar(motivo);
      onClose();
    } catch (error) {
      console.error('Erro ao reprovar:', error);
      alert('Erro ao reprovar orçamento!');
    } finally {
      setEnviando(false);
    }
  };

  if (!isOpen) return null;

  const getNumeroOS = () => {
    const match = oportunidade?.titulo?.match(/OS (\d+)/);
    return match ? match[1] : '';
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>❌ Reprovar Orçamento - OS #{getNumeroOS()}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="info-section">
              <p style={{marginBottom: '20px', color: '#666'}}>
                <strong>Cliente:</strong> {oportunidade?.cliente_nome}
              </p>
              
              <div className="form-group">
                <label>Motivo da Reprovação *</label>
                <textarea
                  value={motivo}
                  onChange={(e) => setMotivo(e.target.value)}
                  placeholder="Descreva o motivo da reprovação deste orçamento..."
                  rows="6"
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
                <small>Mínimo 10 caracteres. Esta informação será salva no Gestão Click.</small>
              </div>

              <div style={{
                background: '#fff3cd',
                padding: '15px',
                borderRadius: '8px',
                border: '1px solid #ffc107',
                marginTop: '20px'
              }}>
                <p style={{margin: 0, fontSize: '14px'}}>
                  ⚠️ <strong>Atenção:</strong> Esta ação irá:
                </p>
                <ul style={{marginTop: '10px', marginBottom: 0, paddingLeft: '20px', fontSize: '14px'}}>
                  <li>Remover a OS do CRM</li>
                  <li>Marcar como "Orçamento Reprovado" no Gestão Click</li>
                  <li>Salvar o motivo nas observações internas</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              type="button" 
              onClick={onClose} 
              className="btn-secondary"
              disabled={enviando}
            >
              Cancelar
            </button>
            <button 
              type="submit" 
              className="btn-danger"
              disabled={enviando}
              style={{
                backgroundColor: '#dc3545',
                color: 'white'
              }}
            >
              {enviando ? '⏳ Reprovando...' : '❌ Confirmar Reprovação'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ReprovacaoModal;
